export default __webpack_public_path__ + "static/media/logo-11-rixos-hotel.b2aabb61.png";